import { Base } from '../base-component';
import './tabs.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
import * as $ from 'jquery';

export class Tabs extends Base {

    tabComponent: JQuery<HTMLElement>;
    slideRunner: JQuery<HTMLElement>;
    activeTab: JQuery<HTMLElement>;
    tabsContent: Array<HTMLElement>;
    tabTriggers: Array<HTMLElement>;
    activeTabTrigger: JQuery<HTMLElement>;
    autoHeight: string;

    constructor(element: Element) {

        super(element);

    }

    init() {
        if (this.element.getAttribute('data-autoheight')) {
            this.autoHeight = this.element.getAttribute('data-autoheight').toString();
        }
        else {
            this.autoHeight = 'true';
        }
        this.tabComponent = $(this.element);
        this.tabsContent = Array.from(this.tabComponent.find('.tabs__item-content'));

        setTimeout(() => {
            this.equalHeights();
        }, 100);

        this.initTabs();

        this.slideRunner = this.tabComponent.find('.tabs__slide-runner');
        this.tabTriggers = Array.from(this.tabComponent.find('.js-tab-trigger'));
        this.activeTabTrigger = this.tabComponent.find('.tabs__item--active');
        this.activeTab = this.tabComponent.find('.tabs__item-content--active');

        $(document).ready(() => {
            this.moveSlideRunner();
        });

    }

    bindEvents() {

        this.tabTriggers.map((item) => item.addEventListener('click', (event) => {

            this.toggleTabs(event);
            this.moveSlideRunner();

        }));

        window.addEventListener('resize', this.debounce(() => {

            this.moveSlideRunner();

        }, 250, false));

        window.addEventListener('resize', this.onResize.bind(this));

    }

    onResize() {

        setTimeout(() => {
            this.equalHeights();
        }, 100);

    }

    initTabs() {

        let tabs = this.tabComponent.find('.tabs__item');
        let tabsContent = this.tabsContent;

        for (let i = 0; i < tabs.length; i++) {

            let tabGuid = this.generateGuid();

            $(tabs[i]).attr('data-target', `tabs__item-${tabGuid}`);
            $(tabsContent[i]).attr('id', `tabs__item-${tabGuid}`);

        }

    }

    equalHeights() {
        if (this.autoHeight == 'true') {
            let elements = this.tabsContent;

            for (let i = 0; i < elements.length; i++) {
                elements[i].style.height = 'auto';
            }

            if (MediaQueryService.getMediaQuery() !== 'small' && MediaQueryService.getMediaQuery() !== 'x-small') {

                let tallestElement = 0;

                for (let i = 0; i < elements.length; i++) {
                    let el = elements[i];
                    let elHeight = el.offsetHeight;

                    if (elHeight > tallestElement) {
                        tallestElement = elHeight;
                    }
                }
                for (let i = 0; i < elements.length; i++) {

                    elements[i].style.height = `${tallestElement}px`;

                    if (!elements[i].classList.contains('tabs__item-content--active')) {
                        elements[i].style.height = '0';
                    }
                }
            }
        }
    }

    toggleTabs(event) {

        if (!$(event.currentTarget).hasClass('tabs__item--active')) {

            this.closeTab();

            this.activeTabTrigger = $(event.currentTarget);
            this.activeTab = this.tabComponent.find(`#${this.activeTabTrigger.attr('data-target')}`);

            this.openTab();

        }

        this.equalHeights();

    }

    moveSlideRunner() {

        let tabPositionLeft = this.activeTabTrigger.position().left;
        let tabWidth = this.activeTabTrigger.width();

        this.slideRunner
            .width(0)
            .css('left', `${tabPositionLeft}px`)
            .show()
            .delay(350)
            .width(tabWidth);

    }

    generateGuid() {

        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {

            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);

        });

    }

    closeTab() {

        this.activeTabTrigger.removeClass('tabs__item--active');
        this.activeTab.removeClass('tabs__item-content--active');

    }

    openTab() {

        this.activeTabTrigger.addClass('tabs__item--active');
        this.activeTab.addClass('tabs__item-content--active');

    }

    debounce(func, wait, immediate) {
        let timeout;
        return function () {

            let context = this, args = arguments;
            let later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);

        };
    }

}



// WEBPACK FOOTER //
// ./components/tabs/tabs.component.ts